// @core/api/endpoints/analytics/query_aggregation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  QueryAggregationRequest,
  QueryAggregationResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Query aggregated data
 * Returns grouped aggregations of product data. Used for pie charts, bar charts, and summary tables.
 */
export async function QueryAggregation(
  data: QueryAggregationRequest,
  options?: RequestOptions
): Promise<QueryAggregationResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/query/aggregation`;
  const requestOptions = options;
  return client.post<QueryAggregationResponse>(requestPath, data, requestOptions);
}
